import { Controller, useFormContext } from "react-hook-form";

import { Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

import { CustomNumberField } from "@/features/ui";

const UsageLimitsSection = () => {
  const { control } = useFormContext();

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Batas Penggunaan
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <Controller
            name="globalUsageLimit"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <CustomNumberField
                {...field}
                label="Batas Penggunaan Global"
                required
                error={!!error}
                helperText={error?.message}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <Controller
            name="perCustomerLimit"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <CustomNumberField
                {...field}
                label="Batas Per Pelanggan"
                error={!!error}
                helperText={error?.message}
              />
            )}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default UsageLimitsSection;
